// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Anuphan[wght].ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/MullerLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/MullerMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Muller-ExtraBold-DEMO.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Pepper Type - Ruberoid-UltraLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Ruberoid-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Authentic Signature.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Anuphan";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
}

@font-face {
  font-family: "Anuphan-bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: bold;
}

@font-face {
    font-family: Muller;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
    font-weight: normal;
}
@font-face {
    font-family: Muller-medium;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
    font-weight: 500;
}
@font-face {
    font-family: Muller-bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
    font-weight: 800;
}
@font-face {
  font-family: Ruberoid-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: Ruberoid-bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: Authentic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
/* Exemplo de classes para utilizar as fontes */
.text-regular {
  font-family: "MinhaFonte", sans-serif;
  font-weight: normal;
}

.text-bold {
  font-family: "MinhaFonte", sans-serif;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Fonts.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAgE;EAChE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+DAAgE;EAChE,iBAAiB;AACnB;;AAEA;IACI,mBAAmB;IACnB,+DAA4D;IAC5D,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,+DAA6D;IAC7D,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,+DAAsE;IACtE,gBAAgB;AACpB;AACA;EACE,2BAA2B;EAC3B,4CAAkE;AACpE;AACA;EACE,0BAA0B;EAC1B,4CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,4CAAkD;AACpD;AACA,+CAA+C;AAC/C;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB","sourcesContent":["@font-face {\n  font-family: \"Anuphan\";\n  src: url(\"../assets/fonts/Anuphan[wght].ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"Anuphan-bold\";\n  src: url(\"../assets/fonts/Anuphan[wght].ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n    font-family: Muller;\n    src: url(../assets/fonts/MullerLight.ttf) format(\"opentype\");\n    font-weight: normal;\n}\n@font-face {\n    font-family: Muller-medium;\n    src: url(../assets/fonts/MullerMedium.ttf) format(\"opentype\");\n    font-weight: 500;\n}\n@font-face {\n    font-family: Muller-bold;\n    src: url(../assets/fonts/Muller-ExtraBold-DEMO.ttf) format(\"opentype\");\n    font-weight: 800;\n}\n@font-face {\n  font-family: Ruberoid-Light;\n  src: url(../assets/fonts/Pepper\\ Type\\ -\\ Ruberoid-UltraLight.otf);\n}\n@font-face {\n  font-family: Ruberoid-bold;\n  src: url(../assets/fonts/Ruberoid-Bold.otf);\n}\n@font-face {\n  font-family: Authentic;\n  src: url(../assets/fonts/Authentic\\ Signature.otf);\n}\n/* Exemplo de classes para utilizar as fontes */\n.text-regular {\n  font-family: \"MinhaFonte\", sans-serif;\n  font-weight: normal;\n}\n\n.text-bold {\n  font-family: \"MinhaFonte\", sans-serif;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
